import Visionaryholdings from './Visionaryholdings'

export default Visionaryholdings
